<div class="relative w-20 h-20">
  <div
    class="w-full h-full rounded-full flex items-center justify-center shadow-inner"
    [ngStyle]="{ background: progressBackground }"
  >
    <div class="w-14 h-14 bg-white rounded-full flex items-center justify-center shadow">
      <span
        class="text-3xl font-bold"
        [ngClass]="countdownRemaining <= 10 ? 'text-red-500' : 'text-blue-600'"
      >
        {{ countdownRemaining }}
      </span>
    </div>
  </div>
</div>
